<template>
  <div id="filtro-primer-nivel-buscador">

    <v-form v-model="filtros_primer_nivel_valido" ref="formulario_filtros_primer_nivel_buscador">

      <v-row class="d-flex align-center fila-filtro">

        <div class="filtro opciones-busqueda pl-3">
          <v-autocomplete
            :items="opciones_busqueda"
            attach
            dense
            label="Buscar acuerdos"
            v-model="filtros.buscar_por"
          ></v-autocomplete>
        </div>

        <div
          v-if="filtros.buscar_por !== FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS"
          class="filtro administracion pb-0"
        >
          <v-text-field
            v-model="administracion_filtrada"
            dense
            clearable
            persistent-hint
            :hint="filtros.buscar_por === FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION ? 'Obligatorio' : ''"
            label="Email o ID de administración"
            :rules="activar_validacion_error && activarValidacionCampoBusquedaAcuerdosAdministracion ? [reglas.requerido] : []"
          >
          </v-text-field>
        </div>
        <div class="filtro consorcio" v-else>
          <v-text-field
            v-model="consorcio_filtrado"
            dense
            clearable
            label="ID de consorcio"
            :rules="activar_validacion_error && activarValidacionCamposBusquedaAcuerdosConsorcios ? [reglas.requerido_sin_mensaje_error] : []"
          >
          </v-text-field>
        </div>

        <div class="filtro periodo" v-if="filtros.buscar_por !== FILTRO_BUSCAR_ACUERDOS_POR_DEFECTO">
          <ca-input-datepicker
            label="Mes de inicio"
            type="month"
            format="MMM. yyyy"
            clearable
            :class="{'error-icon': activarValidacionCamposBusquedaAcuerdosConsorcios && activar_validacion_error}"
            :fecha.sync="filtros.periodo_a_filtrar_inicio"
            :rules="activar_validacion_error && activarValidacionCamposBusquedaAcuerdosConsorcios ? [reglas.requerido_sin_mensaje_error] : []"
          >
          </ca-input-datepicker>
        </div>

        <div class="filtro periodo">
          <ca-input-datepicker
            label="Creación"
            type="month"
            format="MMM. yyyy"
            clearable
            :class="{'error-icon': activarValidacionCamposBusquedaAcuerdosConsorcios && activar_validacion_error}"
            :fecha.sync="filtros.periodo_a_filtrar_creacion"
            :max="periodoActual"
            :rules="activar_validacion_error && activarValidacionCamposBusquedaAcuerdosConsorcios ? [reglas.requerido_sin_mensaje_error] : []"
          >
          </ca-input-datepicker>
        </div>

        <div class="filtro pb-0">
          <v-btn @click="actualizarFiltrosYBuscar">Buscar</v-btn>
        </div>

      </v-row>

    </v-form>
  </div>
</template>

<script>
import {formatFecha} from '@/components/vue_filters';
import { FILTRO_TAB_BUSCADOR_DE_CONSORCIOS, FILTRO_TAB_BUSCADOR_DE_UNA_ADMINISTRACION, FILTRO_TAB_BUSCADOR_POR_DEFECTO, FILTROS_TAB_BUSCADOR, TIPO_BUSQUEDA_ACUERDO_COMERCIAL_ADMINISTRACION, TIPO_BUSQUEDA_ACUERDO_COMERCIAL_CONSORCIOS, TIPO_BUSQUEDA_ACUERDO_COMERCIAL_POR_DEFECTO } from '../acuerdo-comercial.consts';

export default {
  name: 'FiltrosPrimerNivelBuscador',
  data(){
    return {
      opciones_busqueda: FILTROS_TAB_BUSCADOR,
      FILTRO_BUSCAR_ACUERDOS_POR_DEFECTO: FILTRO_TAB_BUSCADOR_POR_DEFECTO.value,
      FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION: FILTRO_TAB_BUSCADOR_DE_UNA_ADMINISTRACION.value,
      FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS: FILTRO_TAB_BUSCADOR_DE_CONSORCIOS.value,

      // Valores de los inputs
      administracion_filtrada: null,
      consorcio_filtrado: null,

      filtros: this.generarFiltros(),

      filtros_primer_nivel_valido: false, // Flag que tiene el estado del formulario cuando se hace la validación
      activar_validacion_error: false, // Flag para indicar cuando activar la validación de error en los campos (esto se utilizá para evitar que cuando está en foco el campo y se sale del mismo sin completar nada, se apliqué la validación)
      reglas: {
        requerido: (valor) => !!valor  || 'Campo obligatorio',
        requerido_sin_mensaje_error: (valor) => !!valor,
      }
    };
  },
  computed: {

    /**
     * Computed para saber si se deben validar, activando las reglas, los campos asociados al tipo de búsqueda de acuerdo por administración.
     * Retorna true cuando es necesario validar, false en caso contrario
     */
    activarValidacionCampoBusquedaAcuerdosAdministracion(){
      return this.filtros.buscar_por === this.FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION;
    },

    /**
     * Computed para saber si se deben validar, activando las reglas, los campos asociados al tipo de búsqueda de acuerdo por consorcio.
     * Retorna true cuando es necesario validar, false en caso contrario
     */
    activarValidacionCamposBusquedaAcuerdosConsorcios(){
      if(this.filtros.buscar_por === this.FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS) {
        return !this.filtros.periodo_a_filtrar_inicio && !this.filtros.periodo_a_filtrar_creacion && !this.consorcio_filtrado;
      }
      return false;
    },

    /**
     * Devuelve los filtros actuales según los inputs
     */
    filtrosActuales() {
      let filtros = this.getFiltrosIniciales();

      // Seteo el tipo de acuerdo según el tipo de búsqueda (administración, consorcio o por defecto)
      switch(this.filtros.buscar_por) {
      case this.FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION:
        filtros.tipo_acuerdo = TIPO_BUSQUEDA_ACUERDO_COMERCIAL_ADMINISTRACION;
        break;
      case this.FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS:
        filtros.tipo_acuerdo = TIPO_BUSQUEDA_ACUERDO_COMERCIAL_CONSORCIOS;
        break;
      case this.FILTRO_BUSCAR_ACUERDOS_POR_DEFECTO:
        filtros.tipo_acuerdo = TIPO_BUSQUEDA_ACUERDO_COMERCIAL_POR_DEFECTO;
        break;
      }

      filtros.administracion = this.filtros.buscar_por === this.FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION || this.filtros.buscar_por === this.FILTRO_BUSCAR_ACUERDOS_POR_DEFECTO ? this.administracion_filtrada : null;
      filtros.consorcio_id = this.filtros.buscar_por === this.FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS ? this.consorcio_filtrado : null;
      filtros.periodo_inicio = this.filtros.periodo_a_filtrar_inicio ?? null;
      filtros.periodo_creacion = this.filtros.periodo_a_filtrar_creacion ?? null;

      return filtros;
    },

    /**
     * Calculo y formateo la fecha actual
     *  - Datapicker de periodo de incio: sin fecha maxima
     *  - Datepicker de fecha creación: limitado a la fecha actual
     */
    periodoActual() {
      let fecha_actual = new Date();
      fecha_actual.setMonth(fecha_actual.getMonth());
      return formatFecha(fecha_actual, 'yyyy-MM');
    },

  },
  watch: {
    /**
     * Watch necesario para reiniciar aquellos campos que se modificaron al cambiar el tipo de búsqueda de acuerdos
     */
    'filtros.buscar_por'(tipo_busqueda_acuerdos){
      this.activar_validacion_error = false; // Desactivó la validación de errores en los campos (reinicio el valor del flag para evitar que se muestren errores)
      this.$refs.formulario_filtros_primer_nivel_buscador.resetValidation(); // Con cada cambio de tipo de busqueda se resetea la validación

      // Reinicio aquellos campos que no tiene en común con el resto de los distintos tipos de búsqueda
      switch(tipo_busqueda_acuerdos) {
      case this.FILTRO_BUSCAR_ACUERDOS_POR_ADMINISTRACION:
        this.consorcio_filtrado = null;
        break;
      case this.FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS:
        this.administracion_filtrada = null;
        break;
      case this.FILTRO_BUSCAR_ACUERDOS_POR_DEFECTO:
        this.consorcio_filtrado = null;
        this.filtros.periodo_a_filtrar_inicio = null;
        break;
      }
    },
  },
  mounted(){
    this.filtros = this.generarFiltros();
  },
  methods: {

    /**
     * Retorna un objeto con los filtros iniciales
     */
    getFiltrosIniciales() {
      return {
        usuario: null,
        libre: false, // False porque son todos los acuerdos, no solo las libres [acuerdo_libre - no esta en uso actualmente]
        administracion: null,
        consorcio_id: null,
        periodo_inicio: null,
        periodo_creacion: null,
        tipo_acuerdo: null,
      };
    },

    /**
     * Metodo para inicializar los filtros
     */
    generarFiltros(){

      // Necesarios estas asignaciones para reiniciar los valores de estos campos (ya que no estan dentro del objeto filtros)
      this.administracion_filtrada = null;
      this.consorcio_filtrado = null;

      return {
        buscar_por: this.FILTRO_BUSCAR_ACUERDOS_POR_CONSORCIOS,
        periodo_a_filtrar_inicio: null,
        periodo_a_filtrar_creacion: null,
      };
    },

    /**
     * Metodo para actualizar y reiniciar los filtros
     */
    reiniciarFiltros() {
      this.filtros = this.generarFiltros();
    },

    /**
     * Emite los filtros actuales para realizar la búsqueda de acuerdos comerciales solo si el formulario es valido
     */
    async actualizarFiltrosYBuscar() {
      this.activar_validacion_error = true; // Activó la validación de errores en los campos
      const formulario_valido = await this.$refs.formulario_filtros_primer_nivel_buscador.validate();

      if (formulario_valido && this.filtros_primer_nivel_valido) {
        this.$emit('filtros:actualizar', this.filtrosActuales);
        this.activar_validacion_error = false; // Desactivó la validación de errores en los campos
      }
    },
  },
};
</script>

<style lang="scss">
#filtro-primer-nivel-buscador {
  margin-bottom: 10px;

  .error-icon {
    .v-icon {
    color: color(rojo-error) !important;
    }
  }

  .error--text{
    color: color(rojo-error) !important;
  }

  .v-input.error--text .v-input__control {
    color: color(rojo-error) !important;
  }

  .fila-filtro {
    display: flex;
    align-items: flex-end;

    .filtro {
      padding-left: 20px;
      padding-bottom: 14px; // Necesario para alinear campos (por la altura del label hint 14px)
      .v-text-field__details {
        display: none;
      }
      &.opciones-busqueda {
        max-width: 220px;
      }
      &.administracion{
        width: 280px;
        .v-text-field__details {
          display: block;
        }
      }
      &.consorcio {
        width: 280px;
      }
      &.periodo {
        width: 190px;
      }
    }
  }
}
</style>